<div class="sidebar boxs1 sidehover" tourAnchor="dashboard-sidebar">
  {{setTourTitle()}}
  <div class="logohome boxs1">
    <a (click)="goToLandingPage()" class="hidden responsivelogo"><img src="{{imgUrl + 'img/obsidiam_welcome.png'}}"
        class="img-responsive responsivelogo"></a>
    <a (click)="goToLandingPage()" class="dekstoplogo1"><img src="./assets/images/obsidiam_logo_blanco.png"
        class="img-responsive dekstoplogo1 "></a>
  </div>

  <ul class="boxs1">
    <li>
      <div id="DashBoardTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('DASHBOARD',false); collapseAll(false)"
          [routerLink]="['/dashboard']" [ngClass]="activeMenu==1?'active selectLi':''">
          <svg *ngIf="activeMenu!=1" xmlns="http://www.w3.org/2000/svg" width="24" height="18" color="red"
            viewBox="0 0 24 18">
            <defs>
              <linearGradient id="a" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(--color-stop-1)" />
                <stop offset="100%" stop-color="var(--color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#a)" fill-rule="evenodd"
              d="M16.333 17h-1.777c-.982 0-1.778-.733-1.778-1.636V9.636H9.222v5.728c0 .903-.796 1.636-1.778 1.636H5.667C4.194 17 3 15.901 3 14.545V8.818C3 8.366 3.398 8 3.889 8c.49 0 .889.366.889.818v5.727c0 .452.398.819.889.819h1.777V9.636C7.444 8.733 8.24 8 9.222 8h3.556c.982 0 1.778.733 1.778 1.636v5.728h1.777c.491 0 .89-.367.89-.819V8.818c0-.452.397-.818.888-.818s.889.366.889.818v5.727C19 15.901 17.806 17 16.333 17zm5.533-10.377a.808.808 0 0 0-.242-1.128l-7.81-4.97a3.389 3.389 0 0 0-3.624 0l-7.81 4.97a.809.809 0 0 0-.245 1.132c.25.38.767.487 1.154.241l7.809-4.97a1.694 1.694 0 0 1 1.817 0l7.809 4.97a.843.843 0 0 0 1.15-.237l-.008-.008z" />
          </svg>
          <img *ngIf="activeMenu==1" width="24" height="18" src="{{imgUrl + 'img/obsidiam_dashboard-active.svg'}}">
          <div *ngIf="notification.dashboard"
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>

      <a *ngIf="!isSmallSidebar" (click)="checkFirstClick('DASHBOARD',false); collapseAll(false)"
        [routerLink]="['/dashboard']" [ngClass]="activeMenu==1?'active selectLi':''">
        <svg *ngIf="activeMenu!=1" xmlns="http://www.w3.org/2000/svg" width="24" height="18" color="red"
          viewBox="0 0 24 18">
          <defs>
            <linearGradient id="a" x1="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="var(--color-stop-1)" />
              <stop offset="100%" stop-color="var(--color-stop-2)" />
            </linearGradient>
          </defs>
          <path fill="url(#a)" fill-rule="evenodd"
            d="M16.333 17h-1.777c-.982 0-1.778-.733-1.778-1.636V9.636H9.222v5.728c0 .903-.796 1.636-1.778 1.636H5.667C4.194 17 3 15.901 3 14.545V8.818C3 8.366 3.398 8 3.889 8c.49 0 .889.366.889.818v5.727c0 .452.398.819.889.819h1.777V9.636C7.444 8.733 8.24 8 9.222 8h3.556c.982 0 1.778.733 1.778 1.636v5.728h1.777c.491 0 .89-.367.89-.819V8.818c0-.452.397-.818.888-.818s.889.366.889.818v5.727C19 15.901 17.806 17 16.333 17zm5.533-10.377a.808.808 0 0 0-.242-1.128l-7.81-4.97a3.389 3.389 0 0 0-3.624 0l-7.81 4.97a.809.809 0 0 0-.245 1.132c.25.38.767.487 1.154.241l7.809-4.97a1.694 1.694 0 0 1 1.817 0l7.809 4.97a.843.843 0 0 0 1.15-.237l-.008-.008z" />
        </svg>
        <img *ngIf="activeMenu==1" width="24" height="18" src="{{imgUrl + 'img/obsidiam_dashboard-active.svg'}}">
        <div class="title-sidebar" tourAnchor="dashboard-sidebar-step">{{'sidebar.dashboard'|translate}}</div>
        <div *ngIf="notification.dashboard"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
      </a>
    </li>

    <li *ngIf="userService.isEnabledModule('PRICES')">
      <div id="PricesTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('PRICE',false); collapseAll(false)"
          [routerLink]="['/prices']" [ngClass]="activeMenu==2?'active selectLi':''">
          <svg *ngIf="activeMenu!=2" width="22" height="18" viewBox="0 0 79 59" version="1.1"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 58 (84663) - https://sketch.com -->
            <g id="Page-1" fill="url(#z)" fill-rule="evenodd">
              <g id="Artboard" transform="translate(-657.000000, -794.000000)" fill="#FFFFFF">
                <defs>
                  <linearGradient id="z" x1="0%" y1="0%" y2="100%">
                    <stop offset="0%" stop-color="var(--color-stop-1)" />
                    <stop offset="100%" stop-color="var(--color-stop-2)" />
                  </linearGradient>
                </defs>
                <path fill="url(#z)" fill-rule="evenodd"
                  d="M732.708333,853 L666.875,853 C661.421188,853 657,848.597467 657,843.166667 L657,797.277778 C657,795.467511 658.473729,794 660.291667,794 C662.109604,794 663.583333,795.467511 663.583333,797.277778 L663.583333,843.166667 C663.583333,844.976933 665.057063,846.444444 666.875,846.444444 L732.708333,846.444444 C734.526271,846.444444 736,847.911956 736,849.722222 C736,851.532489 734.526271,853 732.708333,853 Z M675.219938,839.374818 L686.887085,830.395446 C688.172559,829.40326 690.027338,829.497174 691.197447,830.613695 L692.558615,831.923186 C696.146395,835.375443 701.890557,835.592685 705.748972,832.42204 L723.865458,817.487599 C724.745427,816.763566 725.157041,815.642898 724.945251,814.547738 C724.733461,813.452578 723.930441,812.549308 722.838683,812.178181 C721.746924,811.807054 720.53229,812.024453 719.652322,812.748486 L701.535836,827.682927 C700.250783,828.749067 698.328455,828.681077 697.128247,827.527035 L695.76708,826.217544 C692.260853,822.840196 686.673666,822.544567 682.803584,825.531619 L671.136437,834.510991 C669.805236,835.604546 669.617252,837.517443 670.71184,838.831628 C671.806427,840.145812 673.787972,840.386302 675.187529,839.374818 L675.219938,839.374818 Z"
                  id="Infographic"></path>
              </g>
            </g>
          </svg>
          <img *ngIf="activeMenu==2" width="22" class="ng-star-inserted" height="18"
            src="{{imgUrl + 'img/obsidiam_Infographic-color.svg'}}">
          <div *ngIf="notification.prices"
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>

      <a tourAnchor="prices-tab" *ngIf="!isSmallSidebar" (click)="checkFirstClick('PRICE',false); collapseAll(false)"
        [routerLink]="['/prices']" [ngClass]="activeMenu==2?'active selectLi':''">
        <svg *ngIf="activeMenu!=2" width="22" height="18" viewBox="0 0 79 59" version="1.1"
          xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 58 (84663) - https://sketch.com -->
          <g id="Page-1" fill="url(#z)" fill-rule="evenodd">
            <g id="Artboard" transform="translate(-657.000000, -794.000000)" fill="#FFFFFF">
              <defs>
                <linearGradient id="z" x1="0%" y1="0%" y2="100%">
                  <stop offset="0%" stop-color="var(--color-stop-1)" />
                  <stop offset="100%" stop-color="var(--color-stop-2)" />
                </linearGradient>
              </defs>
              <path fill="url(#z)" fill-rule="evenodd"
                d="M732.708333,853 L666.875,853 C661.421188,853 657,848.597467 657,843.166667 L657,797.277778 C657,795.467511 658.473729,794 660.291667,794 C662.109604,794 663.583333,795.467511 663.583333,797.277778 L663.583333,843.166667 C663.583333,844.976933 665.057063,846.444444 666.875,846.444444 L732.708333,846.444444 C734.526271,846.444444 736,847.911956 736,849.722222 C736,851.532489 734.526271,853 732.708333,853 Z M675.219938,839.374818 L686.887085,830.395446 C688.172559,829.40326 690.027338,829.497174 691.197447,830.613695 L692.558615,831.923186 C696.146395,835.375443 701.890557,835.592685 705.748972,832.42204 L723.865458,817.487599 C724.745427,816.763566 725.157041,815.642898 724.945251,814.547738 C724.733461,813.452578 723.930441,812.549308 722.838683,812.178181 C721.746924,811.807054 720.53229,812.024453 719.652322,812.748486 L701.535836,827.682927 C700.250783,828.749067 698.328455,828.681077 697.128247,827.527035 L695.76708,826.217544 C692.260853,822.840196 686.673666,822.544567 682.803584,825.531619 L671.136437,834.510991 C669.805236,835.604546 669.617252,837.517443 670.71184,838.831628 C671.806427,840.145812 673.787972,840.386302 675.187529,839.374818 L675.219938,839.374818 Z"
                id="Infographic"></path>
            </g>
          </g>
        </svg>
        <img *ngIf="activeMenu==2" width="22" height="18" src="{{imgUrl + 'img/obsidiam_Infographic-color.svg'}}">
        <div class="title-sidebar">{{'sidebar.prices'|translate}}</div>
        <div *ngIf="notification.prices"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
      </a>
    </li>

    <!-- <li *ngIf="userService.isEnabledModule('OBSICASH')">
      <div id="obsicashTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" [routerLink]="['/obsicash/sell-buy']" [ngClass]="activeMenu==3?'active selectLi':''">
          <img *ngIf="activeMenu!=3" width="22" height="18"
            src="assets/images/thin-0431_money_atm_machine_withdrawal_cash.svg">

          <img *ngIf="activeMenu==3" width="22" height="18"
            src="assets/images/thin-0431_money_atm_machine_withdrawal_cash_blue.svg">
          <div *ngIf="notification.obsicash"
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>


      <a *ngIf="!isSmallSidebar" [routerLink]="['/obsicash/sell-buy']" [ngClass]="activeMenu==3?'active selectLi':''">
        <img *ngIf="activeMenu!=3" width="24" height="23"
          src="assets/images/thin-0431_money_atm_machine_withdrawal_cash.svg">

        <img *ngIf="activeMenu==3" width="24" class="ng-star-inserted" height="23"
          src="assets/images/thin-0431_money_atm_machine_withdrawal_cash_blue.svg">

        <div class="title-sidebar">{{'Obsicash'|translate}}</div>
        <div *ngIf="notification.obsicash"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        <div>
          <img style='margin-left: 5px;height:25px' class="galleryImg" src="assets/images/new_2.svg">
        </div>
      </a>
    </li> -->

    <!-- Buy cripto with -->
    <!-- <li *ngIf="userService.isEnabledModule('BANXA')">
      <div id="BuyWithTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('PAYMENT','payment'); collapseAll(false)"
          [ngClass]="activeMenu==8?'active selectLi':''">
          <svg *ngIf="activeMenu!=8" xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
            <defs>
              <linearGradient id="b" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(--color-stop-1)" />
                <stop offset="100%" stop-color="var(--color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#b)" fill-rule="evenodd"
              d="M21 16H3a3 3 0 0 1-3-3V7a2 2 0 0 1 2-2h20V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1 1 1 0 1 1-2 0 3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v2a2 2 0 0 1-2 2H2v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3a1 1 0 1 1 2 0v3a3 3 0 0 1-3 3z" />
          </svg>
          <img *ngIf="activeMenu==8" width="24" height="16" src="{{imgUrl + 'img/obsidiam_card-active.svg'}}">
        </a>
      </div>
      <a tourAnchor="payment-tab" *ngIf="!isSmallSidebar"
        (click)="checkFirstClick('PAYMENT','payment'); collapseAll(false)"
        [ngClass]="activeMenu==8?'active selectLi':''">
        <svg *ngIf="activeMenu!=8" xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
          <defs>
            <linearGradient id="b" x1="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="var(--color-stop-1)" />
              <stop offset="100%" stop-color="var(--color-stop-2)" />
            </linearGradient>
          </defs>
          <path fill="url(#b-1)" fill-rule="evenodd"
            d="M21 16H3a3 3 0 0 1-3-3V7a2 2 0 0 1 2-2h20V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1 1 1 0 1 1-2 0 3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v2a2 2 0 0 1-2 2H2v6a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3a1 1 0 1 1 2 0v3a3 3 0 0 1-3 3z" />
        </svg>
        <img *ngIf="activeMenu==8" width="24" height="16" src="{{imgUrl + 'img/obsidiam_card-active.svg'}}">
        <div style='position: absolute;left:38px;display: flex;flex-direction: row;align-items: center;'>
          <div class="title-sidebar" style='color:#fff'>{{'sidebar.buy_with_cc_dc' | translate}}</div>
          <img height="35" style='margin-left: 5px;' src="{{imgUrl + 'img/obsidiam_visamastercard.png'}}">
        </div>
      </a>
    </li> -->
    <!-- Buy and Sell Digital Assets -->
    <li>
      <div id="BuyWithTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" [routerLink]="['obsicash/buyselloption']"
          (click)="checkFirstClick('buyselloption',false);" [ngClass]="activeMenu==4?'active selectLi':''">
          <img *ngIf="activeMenu!=4" width="20" height="16" src="./assets/img/Right_white.png">
          <img *ngIf="activeMenu==4" width="20" height="16" src="./assets/img/Right_blue.png">
        </a>
      </div>

      <a *ngIf="!isSmallSidebar" style="align-items: flex-start;" [routerLink]="['obsicash/buyselloption']"
        (click)="checkFirstClick('buyselloption',false);" [ngClass]="activeMenu==4?'active selectLi':''">
        <img style="margin-top: 3px;" *ngIf="activeMenu!=4" width="20" height="16" src="./assets/img/Right_white.png">
        <img style="margin-top: 3px;" *ngIf="activeMenu==4" width="20" height="16" src="./assets/img/Right_blue.png">

        <!-- <div style='display: flex;flex-direction: column;align-items: center;'>
          <div *ngIf='activeMenu!=4' id="outer" style="width:190px;">
            <div class="title-sidebar fitText" style='color:#fff' >{{'sidebar.buy_sell_digital_asset' | translate}}</div>
          </div>
          <div *ngIf='activeMenu==4' class="title-sidebar"
            style='color:#fff; font-family: RalewayRegular; font-size: 10px;margin-left: 9px;margin-right: 10px;'>
            {{'sidebar.buy_sell_digital_asset_desc' | translate}}</div>
        </div> -->
        <div style='display: flex;flex-direction: column;align-items: center;'>
          <div *ngIf='activeMenu!=4' id="outer" style="width:190px;" tourAnchor="buy-sell-tab1">
            <div class="title-sidebar" style='color:#fff' >{{'sidebar.buy_sell_digital_asset' | translate}}</div>
          </div>
          <div *ngIf='activeMenu==4' class="title-sidebar" style='color:#fff' tourAnchor="buy-sell-tab1">
            {{'sidebar.buy_sell_digital_asset_desc' | translate}}</div>
        </div>
      </a>
    </li>
    <!--Exchange -->
    <li *ngIf="userService.isEnabledModule('EXCHANGE')">
      <div id="ExchangeTooltip1" data-toggle="tooltip" data-placement="left" title=''>
        <a (click)="checkFirstClick('EXCHANGE',false); collapseAll(false)" *ngIf="isSmallSidebar"
          [routerLink]="['/quick-exchange']" [ngClass]="activeMenu==5?'active selectLi':''">

          <svg *ngIf="activeMenu!=5" xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 13 17">
            <defs>
              <linearGradient id="c" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(--color-stop-1)" />
                <stop offset="100%" stop-color="var(--color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#c)" fill-rule="evenodd"
              d="M12.284 13H.71a.712.712 0 0 1-.71-.713c0-.395.318-.714.71-.714h9.692L7.768 9.254a.718.718 0 0 1-.068-1.01.71.71 0 0 1 1.005-.067l4.055 3.567a.716.716 0 0 1-.47 1.249l-.006.007zm-3.94 3.876l1.314-.73c.374-.209.454-.606.177-.888-.277-.282-.805-.342-1.18-.134l-1.313.73c-.374.209-.454.606-.177.888.277.282.805.342 1.18.134zM5.296 8.758a.717.717 0 0 0-.064-1.007L2.598 5.429h9.692c.392 0 .71-.32.71-.715A.712.712 0 0 0 12.29 4H.71a.71.71 0 0 0-.664.462.717.717 0 0 0 .194.788l4.055 3.572a.707.707 0 0 0 1.001-.064zm-1.19-6.932l.666-.595a.728.728 0 0 0 .063-.99.644.644 0 0 0-.941-.067l-.666.595a.728.728 0 0 0-.063.99.644.644 0 0 0 .941.067z" />
          </svg>
          <img *ngIf="activeMenu==5" width="24" height="20" src="{{imgUrl + 'img/obsidiam_exchange-active.svg'}}">
          <div *ngIf="notification.exchange"
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>

      <a (click)="checkFirstClick('EXCHANGE',false); collapseAll(false)" *ngIf="!isSmallSidebar"
        [routerLink]="['/quick-exchange']" [ngClass]="activeMenu==5?'active selectLi':''">
        <svg *ngIf="activeMenu!=5" xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 13 17">
          <defs>
            <linearGradient id="c" x1="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="var(--color-stop-1)" />
              <stop offset="100%" stop-color="var(--color-stop-2)" />
            </linearGradient>
          </defs>
          <path fill="url(#c)" fill-rule="evenodd"
            d="M12.284 13H.71a.712.712 0 0 1-.71-.713c0-.395.318-.714.71-.714h9.692L7.768 9.254a.718.718 0 0 1-.068-1.01.71.71 0 0 1 1.005-.067l4.055 3.567a.716.716 0 0 1-.47 1.249l-.006.007zm-3.94 3.876l1.314-.73c.374-.209.454-.606.177-.888-.277-.282-.805-.342-1.18-.134l-1.313.73c-.374.209-.454.606-.177.888.277.282.805.342 1.18.134zM5.296 8.758a.717.717 0 0 0-.064-1.007L2.598 5.429h9.692c.392 0 .71-.32.71-.715A.712.712 0 0 0 12.29 4H.71a.71.71 0 0 0-.664.462.717.717 0 0 0 .194.788l4.055 3.572a.707.707 0 0 0 1.001-.064zm-1.19-6.932l.666-.595a.728.728 0 0 0 .063-.99.644.644 0 0 0-.941-.067l-.666.595a.728.728 0 0 0-.063.99.644.644 0 0 0 .941.067z" />
        </svg>
        <img *ngIf="activeMenu==5" width="24" height="20" src="{{imgUrl + 'img/obsidiam_exchange-active.svg'}}">
        <div class="title-sidebar" tourAnchor="exchange-sidebar-step">{{'sidebar.exchangeText'|translate}}</div>
        <div *ngIf="notification.exchange"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
      </a>
    </li>

    <!-- <li *ngIf="checkForBothDisable()">
      <div id="BuySellTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('BUYSELL',false); collapseAll(true)"
          [ngClass]="activeMenu==2?'active selectLi':''" data-toggle="collapse" href="#BuySellCollapse" role="button"
          aria-expanded="false" aria-controls="BuySellCollapse" data-parent="#sideBarGroup">
          <img *ngIf="activeMenu!=2" width="24" height="16" src="{{imgUrl + 'img/obsidiam_handshakeIcon.png'}}">
          <img *ngIf="activeMenu==2" width="24" height="16" src="{{imgUrl + 'img/obsidiam_handshakeIconBlue.png'}}">
          <div *ngIf="notification.buy_sell"
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>
      <a *ngIf="!isSmallSidebar" (click)="checkFirstClick('BUYSELL',false); collapseAll(true)"
        [ngClass]="activeMenu==2?'active selectLi':''" data-toggle="collapse" href="#BuySellCollapse" role="button"
        aria-expanded="false" aria-controls="BuySellCollapse" data-parent="#sideBarGroup">
        <img *ngIf="activeMenu!=2" width="24" height="16" src="{{imgUrl + 'img/obsidiam_handshakeIcon.png'}}">
        <img *ngIf="activeMenu==2" width="24" height="16" src="{{imgUrl + 'img/obsidiam_handshakeIconBlue.png'}}">
        <div class="title-sidebar" tourAnchor="buy-sell-sidebar-step">{{'sidebar.buy_sell'|translate}}</div>
        <div *ngIf="notification.buy_sell"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
      </a>
      <div class="collapse" id="BuySellCollapse" aria-expanded="false">
        <div *ngIf="userService.isEnabledModule('P2P MARKET')" tourAnchor="buy-sell-tab1" class="collapse-option"
          [routerLink]="['/buy-sell']">
          {{'sidebar.market'|translate}}</div>
        <div *ngIf="userService.isEnabledModule('P2P PRIVATE')" tourAnchor="buy-sell-tab2" class="collapse-option"
          [routerLink]="['/private-trade']">
          {{'sidebar.private_trade'|translate}}</div>
      </div>
    </li> -->

    <!-- Buy Sell Market -->
    <li *ngIf="userService.isEnabledModule('P2P MARKET')">
      <div id="P2PMarketToolTip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('buy-sell',false); collapseAll(false)"
          [routerLink]="['/buy-sell']" [ngClass]="activeMenu==6?'active selectLi':''">
          <img *ngIf="activeMenu!=6" width="22" height="18" src="./assets/img/Group_white.png">

          <img *ngIf="activeMenu==6" width="22" height="18" src="./assets/img/Group_blue.png">
          <div *ngIf="notification.buy_sell"
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>

      <a tourAnchor="buy-sell-tab1" *ngIf="!isSmallSidebar"
        (click)="checkFirstClick('buy-sell',false); collapseAll(false)" [routerLink]="['/buy-sell']"
        [ngClass]="activeMenu==6?'active selectLi':''">
        <img *ngIf="activeMenu!=6" width="22" height="18" src="./assets/img/Group_white.png">
        <img *ngIf="activeMenu==6" width="22" height="18" src="./assets/img/Group_blue.png">
        <div class="title-sidebar">{{'sidebar.crypto_market'|translate}}</div>
        <div *ngIf="notification.buy_sell"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
      </a>
    </li>

    <!-- Buy Sell Private -->
    <li *ngIf="userService.isEnabledModule('P2P PRIVATE')">
      <div id="PrivateMarketToolTip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('private-trade',false); collapseAll(false)"
          [routerLink]="['/private-trade']" [ngClass]="activeMenu==7?'active selectLi':''">
          <img *ngIf="activeMenu!=7" width="20" height="18" src="./assets/img/Lock_white.png">

          <img *ngIf="activeMenu==7" width="20" height="18" src="./assets/img/Lock_blue.png">
          <div *ngIf="notification.buy_sell"
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>

      <a tourAnchor="buy-sell-tab2" *ngIf="!isSmallSidebar"
        (click)="checkFirstClick('private-trade',false); collapseAll(false)" [routerLink]="['/private-trade']"
        [ngClass]="activeMenu==7?'active selectLi':''">
        <img *ngIf="activeMenu!=7" width="20" height="18" src="./assets/img/Lock_white.png">
        <img *ngIf="activeMenu==7" width="20" height="18" src="./assets/img/Lock_blue.png">
        <div class="title-sidebar">{{'sidebar.private_sales'|translate}}</div>
        <div *ngIf="notification.buy_sell"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
      </a>
    </li>

    <!-- <li *ngIf="userService.isEnabledModule('WALLET')">
      <div id="WalletTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('WALLET',false); collapseAll(false)"
          [routerLink]="['/wallet']" [ngClass]="activeMenu==8?'active selectLi':''">
          <svg *ngIf="activeMenu!=8" xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 24 18">
            <defs>
              <linearGradient id="d" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(--color-stop-1)" />
                <stop offset="100%" stop-color="var(--color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#d)" fill-rule="evenodd"
              d="M19 18H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v1a1 1 0 0 1-2 0V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 1 2 0v1a3 3 0 0 1-3 3zm5-8V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v3a1 1 0 0 0 2 0V8h5v2h-2a1 1 0 0 0 0 2h2a2 2 0 0 0 2-2z" />
          </svg>
          <img *ngIf="activeMenu==8" width="22" height="18" src="{{imgUrl + 'img/obsidiam_wallet-active.svg'}}">
          <div *ngIf="false" class="notification-indicator notification-indicator-danger notification-indicator-ripple">
          </div>
        </a>
      </div>

      <a tourAnchor="wallet-tab" *ngIf="!isSmallSidebar" (click)="checkFirstClick('WALLET',false); collapseAll(false)"
        [routerLink]="['/wallet']" [ngClass]="activeMenu==8?'active selectLi':''">
        <svg *ngIf="activeMenu!=8" xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 24 18">
          <defs>
            <linearGradient id="d" x1="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="var(--color-stop-1)" />
              <stop offset="100%" stop-color="var(--color-stop-2)" />
            </linearGradient>
          </defs>
          <path fill="url(#d)" fill-rule="evenodd"
            d="M19 18H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v1a1 1 0 0 1-2 0V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 1 2 0v1a3 3 0 0 1-3 3zm5-8V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v3a1 1 0 0 0 2 0V8h5v2h-2a1 1 0 0 0 0 2h2a2 2 0 0 0 2-2z" />
        </svg>
        <img *ngIf="activeMenu==8" width="22" height="18" src="{{imgUrl + 'img/obsidiam_wallet-active.svg'}}">
        <div class="title-sidebar">{{'sidebar.wallet'|translate}}</div>
        <div *ngIf="false" class="notification-indicator notification-indicator-danger notification-indicator-ripple">
        </div>
      </a>
    </li> -->

    <!-- send / receive (new wallet section) start -->
    <li *ngIf="userService.isEnabledModule('WALLET')">
      <div id="WalletTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('WALLET',false); collapseAll(false)"
          [routerLink]="['/wallet1']" [ngClass]="activeMenu==8?'active selectLi':''">
          <svg *ngIf="activeMenu!=8" xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 24 18">
            <defs>
              <linearGradient id="d" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(--color-stop-1)" />
                <stop offset="100%" stop-color="var(--color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#d)" fill-rule="evenodd"
              d="M19 18H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v1a1 1 0 0 1-2 0V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 1 2 0v1a3 3 0 0 1-3 3zm5-8V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v3a1 1 0 0 0 2 0V8h5v2h-2a1 1 0 0 0 0 2h2a2 2 0 0 0 2-2z" />
          </svg>
          <img *ngIf="activeMenu==8" width="22" height="18" src="{{imgUrl + 'img/obsidiam_wallet-active.svg'}}">
          <div *ngIf="false" class="notification-indicator notification-indicator-danger notification-indicator-ripple">
          </div>
        </a>
      </div>

      <a tourAnchor="wallet-tab" *ngIf="!isSmallSidebar" (click)="checkFirstClick('WALLET',false); collapseAll(false)"
        [routerLink]="['/wallet1']" [ngClass]="activeMenu==8?'active selectLi':''">
        <svg *ngIf="activeMenu!=8" xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 24 18">
          <defs>
            <linearGradient id="d" x1="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="var(--color-stop-1)" />
              <stop offset="100%" stop-color="var(--color-stop-2)" />
            </linearGradient>
          </defs>
          <path fill="url(#d)" fill-rule="evenodd"
            d="M19 18H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v1a1 1 0 0 1-2 0V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 1 2 0v1a3 3 0 0 1-3 3zm5-8V8a2 2 0 0 0-2-2h-5a2 2 0 0 0-2 2v3a1 1 0 0 0 2 0V8h5v2h-2a1 1 0 0 0 0 2h2a2 2 0 0 0 2-2z" />
        </svg>
        <img *ngIf="activeMenu==8" width="22" height="18" src="{{imgUrl + 'img/obsidiam_wallet-active.svg'}}">
        <div class="title-sidebar">{{'sidebar.send/receive'|translate}}</div>
        <div *ngIf="false" class="notification-indicator notification-indicator-danger notification-indicator-ripple">
        </div>
      </a>
    </li>
    <!--send / receive (new wallet section) ends  -->
    <!-- Add cash/cash out -->
    <li *ngIf="userData.userType != 'BUSINESS' ">
      <div id="CashInOutTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick(activeModuleObsicash,false); collapseAll(false)"
          [routerLink]="[activeModuleObsicash]" [ngClass]="activeMenu==9?'active selectLi':''">

          <img *ngIf="activeMenu!=9" width="20" height="18" src="./assets/img/bank_white.png">

          <img *ngIf="activeMenu==9" width="20" height="18" src="./assets/img/bank_blue.png">
          <div *ngIf="false" class="notification-indicator notification-indicator-danger notification-indicator-ripple">
          </div>
        </a>
      </div>

      <a tourAnchor="cash-out-tab" *ngIf="!isSmallSidebar"
        (click)="checkFirstClick(activeModuleObsicash,false); collapseAll(false)" [routerLink]="[activeModuleObsicash]"
        [ngClass]="activeMenu==9?'active selectLi':''">

        <img *ngIf="activeMenu!=9" width="20" height="18" src="./assets/img/bank_white.png">
        <img *ngIf="activeMenu==9" width="20" height="18" src="./assets/img/bank_blue.png">
        <div class="title-sidebar">{{'sidebar.add_cash_out'|translate}}</div>
        <div *ngIf="false" class="notification-indicator notification-indicator-danger notification-indicator-ripple">
        </div>
      </a>
    </li>


    <li *ngIf="userService.isEnabledModule('ORDERS')">
      <div id="OrdersTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('orders',false); collapseAll(false)"
          [routerLink]="['/orders']" [ngClass]="activeMenu==10?'active selectLi':''">
          <svg *ngIf="activeMenu!=10" xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 21 18">
            <defs>
              <linearGradient id="f" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(--color-stop-1)" />
                <stop offset="100%" stop-color="var(--color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#f)" fill-rule="evenodd"
              d="M17.209 11H7.706c-1.286 0-2.39-.885-2.625-2.105L3.844 2.423a.883.883 0 0 0-.89-.704H.89c-.492 0-.89-.385-.89-.86C0 .385.398 0 .89 0h2.082c1.286 0 2.39.885 2.625 2.105l1.237 6.472a.883.883 0 0 0 .89.704h9.494a.883.883 0 0 0 .89-.704l1.12-5.844a.838.838 0 0 0-.196-.71.903.903 0 0 0-.693-.304H8.009c-.492 0-.89-.385-.89-.86 0-.474.398-.859.89-.859h10.32c.795 0 1.547.34 2.055.93.507.59.716 1.367.57 2.12l-1.12 5.845c-.236 1.22-1.34 2.105-2.625 2.105zM12 15a3 3 0 0 0-3-3 1 1 0 1 0 0 2 1 1 0 1 1-1 1 1 1 0 1 0-2 0 3 3 0 0 0 6 0zm5 2a1 1 0 0 0-1-1 1 1 0 1 1 1-1 1 1 0 1 0 2 0 3 3 0 1 0-3 3 1 1 0 0 0 1-1z" />
          </svg>
          <img *ngIf="activeMenu==10" width="22" height="20" src="{{imgUrl + 'img/obsidiam_cart-active.svg'}}">
          <div *ngIf="notification.order"
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>

      <a tourAnchor="orders-tab" *ngIf="!isSmallSidebar" (click)="checkFirstClick('orders',false); collapseAll(false)"
        [routerLink]="['/orders']" [ngClass]="activeMenu==10?'active selectLi':''">
        <svg *ngIf="activeMenu!=10" xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 21 18">
          <defs>
            <linearGradient id="f" x1="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="var(--color-stop-1)" />
              <stop offset="100%" stop-color="var(--color-stop-2)" />
            </linearGradient>
          </defs>
          <path fill="url(#f)" fill-rule="evenodd"
            d="M17.209 11H7.706c-1.286 0-2.39-.885-2.625-2.105L3.844 2.423a.883.883 0 0 0-.89-.704H.89c-.492 0-.89-.385-.89-.86C0 .385.398 0 .89 0h2.082c1.286 0 2.39.885 2.625 2.105l1.237 6.472a.883.883 0 0 0 .89.704h9.494a.883.883 0 0 0 .89-.704l1.12-5.844a.838.838 0 0 0-.196-.71.903.903 0 0 0-.693-.304H8.009c-.492 0-.89-.385-.89-.86 0-.474.398-.859.89-.859h10.32c.795 0 1.547.34 2.055.93.507.59.716 1.367.57 2.12l-1.12 5.845c-.236 1.22-1.34 2.105-2.625 2.105zM12 15a3 3 0 0 0-3-3 1 1 0 1 0 0 2 1 1 0 1 1-1 1 1 1 0 1 0-2 0 3 3 0 0 0 6 0zm5 2a1 1 0 0 0-1-1 1 1 0 1 1 1-1 1 1 0 1 0 2 0 3 3 0 1 0-3 3 1 1 0 0 0 1-1z" />
        </svg>
        <img *ngIf="activeMenu==10" width="22" height="20" src="{{imgUrl + 'img/obsidiam_cart-active.svg'}}">
        <div class="title-sidebar">{{'sidebar.orders_offers'|translate}}</div>
        <div *ngIf="notification.order"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
      </a>
    </li>
     <!-- promotions start-->
     <li>
      <div id="PromotionTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" [routerLink]="['/quantum/home/promotions']" (click)="checkFirstClick('promotions',false);"
          [ngClass]="activeMenu==12?'active selectLi':''">
          <img *ngIf="activeMenu!=12" width="22" height="20" src="./assets/img/promotion_white.svg">
          <img *ngIf="activeMenu==12" width="22" height="20" src="./assets/img/promotion.svg">
        </a>
      </div>
      <a *ngIf="!isSmallSidebar" style="align-items: flex-start;"
      [routerLink]="['quantum/home/promotions']" (click)="checkFirstClick('promotions',false);"
        [ngClass]="activeMenu==12?'active selectLi':''">
        <img style="margin-top: 3px;" *ngIf="activeMenu!=12" width="22" height="20" src="./assets/img/promotion_white.svg">
        <img style="margin-top: 3px;" *ngIf="activeMenu==12" width="22" height="20" src="./assets/img/promotion.svg">
        <div style='display: flex;flex-direction: column;align-items: center;'>
          <div *ngIf='activeMenu!=12' id="outer" style="width:190px;">
            <div class="title-sidebar" style='color:#fff'>{{'sidebar.promotions' | translate}}</div>
          </div>
          <div *ngIf='activeMenu==12' class="title-sidebar" style='color:#fff'>
            {{'sidebar.promotions' | translate}}</div>
        </div>
      </a>
    </li>
    <!-- promotions end-->
    <li *ngIf="userService.isEnabledModule('OBSIPAY')">
      <div tourAnchor="obispay-tab" id="ObsidiamPayTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" (click)="checkFirstClick('OBSIDIAM_PAY',false); collapseAll(false)"
          [routerLink]="['/quick-transfer']" [ngClass]="activeMenu==11?'active selectLi':''">
          <svg *ngIf="activeMenu!=11" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
            <defs>
              <linearGradient id="e" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(--color-stop-1)" />
                <stop offset="100%" stop-color="var(--color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#e)" fill-rule="evenodd"
              d="M12.089 20.86a1.49 1.49 0 0 1-1.06-.44l-1.06-1.06a1 1 0 1 1 1.41-1.41l.71.71.35-.35a.5.5 0 0 0 .14-.28l.59-4.12a2 2 0 0 1 .57-1.13l2.49-2.49a8.94 8.94 0 0 0 2.64-6.36V2h-1.93a8.94 8.94 0 0 0-6.36 2.64l-2.49 2.49a2 2 0 0 1-1.13.57l-4.13.59a.5.5 0 0 0-.28.14l-.35.35.71.71a1 1 0 1 1-1.41 1.41L.439 9.84a1.5 1.5 0 0 1 0-2.12l.71-.71a2.51 2.51 0 0 1 1.41-.71l4.13-.59 2.49-2.49A10.93 10.93 0 0 1 16.959 0h2.91a1 1 0 0 1 1 1v2.93a10.93 10.93 0 0 1-3.22 7.78l-2.49 2.49-.59 4.13a2.51 2.51 0 0 1-.71 1.41l-.71.71a1.49 1.49 0 0 1-1.06.41zm-4.95-2.91l1.41-1.41a1 1 0 0 0-1.41-1.41l-1.41 1.41a1 1 0 1 0 1.41 1.41zm-4.24-1.41l2.83-2.83a1 1 0 0 0-1.41-1.41l-2.83 2.83a1 1 0 1 0 1.41 1.41zm12.73-7.07a3 3 0 0 0 0-4.24 1 1 0 1 0-1.41 1.41 1 1 0 1 1-1.41 0 1 1 0 0 0-1.41-1.41 3 3 0 1 0 4.24 4.24h-.01z" />
          </svg>
          <img *ngIf="activeMenu==11" width="21" height="21" src="{{imgUrl + 'img/obsidiam_rocket-active.svg'}}">
          <div *ngIf="notification.pay" style='margin-right: 3px !important;
          top: 25% !important;'
            class="notification-indicator notification-indicator-danger notification-indicator-ripple"></div>
        </a>
      </div>

      <a *ngIf="!isSmallSidebar" (click)="checkFirstClick('OBSIDIAM_PAY',false); collapseAll(false)"
        [routerLink]="['/quick-transfer']" [ngClass]="activeMenu==11?'active selectLi':''">
        <svg *ngIf="activeMenu!=11" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
          <defs>
            <linearGradient id="e" x1="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="var(--color-stop-1)" />
              <stop offset="100%" stop-color="var(--color-stop-2)" />
            </linearGradient>
          </defs>
          <path fill="url(#e)" fill-rule="evenodd"
            d="M12.089 20.86a1.49 1.49 0 0 1-1.06-.44l-1.06-1.06a1 1 0 1 1 1.41-1.41l.71.71.35-.35a.5.5 0 0 0 .14-.28l.59-4.12a2 2 0 0 1 .57-1.13l2.49-2.49a8.94 8.94 0 0 0 2.64-6.36V2h-1.93a8.94 8.94 0 0 0-6.36 2.64l-2.49 2.49a2 2 0 0 1-1.13.57l-4.13.59a.5.5 0 0 0-.28.14l-.35.35.71.71a1 1 0 1 1-1.41 1.41L.439 9.84a1.5 1.5 0 0 1 0-2.12l.71-.71a2.51 2.51 0 0 1 1.41-.71l4.13-.59 2.49-2.49A10.93 10.93 0 0 1 16.959 0h2.91a1 1 0 0 1 1 1v2.93a10.93 10.93 0 0 1-3.22 7.78l-2.49 2.49-.59 4.13a2.51 2.51 0 0 1-.71 1.41l-.71.71a1.49 1.49 0 0 1-1.06.41zm-4.95-2.91l1.41-1.41a1 1 0 0 0-1.41-1.41l-1.41 1.41a1 1 0 1 0 1.41 1.41zm-4.24-1.41l2.83-2.83a1 1 0 0 0-1.41-1.41l-2.83 2.83a1 1 0 1 0 1.41 1.41zm12.73-7.07a3 3 0 0 0 0-4.24 1 1 0 1 0-1.41 1.41 1 1 0 1 1-1.41 0 1 1 0 0 0-1.41-1.41 3 3 0 1 0 4.24 4.24h-.01z" />
        </svg>
        <img *ngIf="activeMenu==11" width="21" height="21" src="{{imgUrl + 'img/obsidiam_rocket-active.svg'}}">
        <img tourAnchor="obsidiam-pay-sidebar-step" style="margin-left: 12px;" height="14"
          src="{{imgUrl + 'img/obsidiam_obsipay_white_logo.png'}}">
        <div *ngIf="notification.pay"
          class="notification-indicator notification-indicator-danger notification-indicator-ripple obsi"></div>
      </a>
    </li>
    <!-- Logout -->
    <li class="logout">
      <!--  Obsidiam pro start
      <div id="ObsidiamProTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a (click)="checkFirstClick('EXCHANGE','obsidiamExchange'); collapseAll(true)" *ngIf="isSmallSidebar"
        data-toggle="collapse" href="#ExchangeCollapse" role="button"
        aria-expanded="false" aria-controls="ExchangeCollapse" data-parent="#sideBarGroup" style="cursor: pointer;color: #fff;pointer-events: auto;"
          [ngClass]="activeMenu==9?'active selectLi':''">
          <svg *ngIf="activeMenu!=9" xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 13 17">
            <defs>
              <linearGradient id="c" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(&#45;&#45;color-stop-1)" />
                <stop offset="100%" stop-color="var(&#45;&#45;color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#c)" fill-rule="evenodd"
              d="M12.284 13H.71a.712.712 0 0 1-.71-.713c0-.395.318-.714.71-.714h9.692L7.768 9.254a.718.718 0 0 1-.068-1.01.71.71 0 0 1 1.005-.067l4.055 3.567a.716.716 0 0 1-.47 1.249l-.006.007zm-3.94 3.876l1.314-.73c.374-.209.454-.606.177-.888-.277-.282-.805-.342-1.18-.134l-1.313.73c-.374.209-.454.606-.177.888.277.282.805.342 1.18.134zM5.296 8.758a.717.717 0 0 0-.064-1.007L2.598 5.429h9.692c.392 0 .71-.32.71-.715A.712.712 0 0 0 12.29 4H.71a.71.71 0 0 0-.664.462.717.717 0 0 0 .194.788l4.055 3.572a.707.707 0 0 0 1.001-.064zm-1.19-6.932l.666-.595a.728.728 0 0 0 .063-.99.644.644 0 0 0-.941-.067l-.666.595a.728.728 0 0 0-.063.99.644.644 0 0 0 .941.067z" />
          </svg>
          <img *ngIf="activeMenu==9" width="24" height="18" src="./assets/img/Exchange-Active.svg">
        </a>
      </div>
      <a (click)="checkFirstClick('EXCHANGE','obsidiamExchange'); collapseAll(true)" *ngIf="!isSmallSidebar"
        [ngClass]="activeMenu==9?'active selectLi':''" data-toggle="collapse" href="#ExchangeCollapse" role="button"
        aria-expanded="false" aria-controls="ExchangeCollapse" data-parent="#sideBarGroup"
        style="cursor: pointer;color: #fff;pointer-events: auto;">
        <div><span style='color:#ffffff;
          text-shadow: 0px 1px, 1px 0px, 1px 1px;
          font-size: 12px;
          letter-spacing:1.5px;
          font-weight:bold;' class="font-weight-bold">OBSIDIAM</span><span style='font-size: 12px;'
            class="font-weight-light">| EXCHANGE</span></div>
      </a>
      <div style="pointer-events: auto;" class="collapse" id="ExchangeCollapse" aria-expanded="false">
        <a *ngIf="!isSmallSidebar" class="collapse-option"
          style="cursor: pointer;color: #fff;padding-left: 15px;pointer-events: auto;"
          [routerLink]="['/advance-exchange/BTC_USDT']">
          <div><span style='color:#ffffff;
              text-shadow: 0px 1px, 1px 0px, 1px 1px;
              font-size: 12px;
              letter-spacing:1.5px;
              font-weight:bold;' class="font-weight-bold">OBSIDIAM</span><span style='font-size: 12px;'
              class="font-weight-light">| PRO</span></div>
        </a>
      </div>
       Obsidiam pro ends -->

      <div id="LogOutTooltip" data-toggle="tooltip" data-placement="left" title="">
        <a *ngIf="isSmallSidebar" href="javascript:;" (click)="logOut()">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
            <defs>
              <linearGradient id="g" x1="0%" y1="0%" y2="100%">
                <stop offset="0%" stop-color="var(--color-stop-1)" />
                <stop offset="100%" stop-color="var(--color-stop-2)" />
              </linearGradient>
            </defs>
            <path fill="url(#g)" fill-rule="evenodd" stroke="#FFF" stroke-width=".5"
              d="M8.751 1.042c.437-.047.427.173.474.612.047.44.133.934-.303.98-4.01.821-6.738 4.586-6.292 8.685.445 4.1 3.917 7.182 8.008 7.11 4.092-.071 7.454-3.273 7.756-7.385.302-4.112-2.059-7.729-6.095-8.409-.134-.022.101 6.326.001 7.626-.052.683-.301.784-.512.782-.07 0-.152.015-.203 0-.324-.095-.437-.637-.446-.782-.005-.06-.012-8.544-.002-8.606a.805.805 0 0 1 .923-.67c4.844.814 8.274 5.215 7.912 10.15-.361 4.935-4.396 8.778-9.306 8.864-4.91.085-9.077-3.614-9.61-8.534-.534-4.92 2.74-9.437 7.553-10.42" />
          </svg></a>
      </div>

      <a *ngIf="!isSmallSidebar" style="cursor: pointer;color: #fff;" (click)="logOut()"><svg
          xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
          <defs>
            <linearGradient id="g" x1="0%" y1="0%" y2="100%">
              <stop offset="0%" stop-color="var(--color-stop-1)" />
              <stop offset="100%" stop-color="var(--color-stop-2)" />
            </linearGradient>
          </defs>
          <path fill="url(#g)" fill-rule="evenodd" stroke="#FFF" stroke-width=".5"
            d="M8.751 1.042c.437-.047.427.173.474.612.047.44.133.934-.303.98-4.01.821-6.738 4.586-6.292 8.685.445 4.1 3.917 7.182 8.008 7.11 4.092-.071 7.454-3.273 7.756-7.385.302-4.112-2.059-7.729-6.095-8.409-.134-.022.101 6.326.001 7.626-.052.683-.301.784-.512.782-.07 0-.152.015-.203 0-.324-.095-.437-.637-.446-.782-.005-.06-.012-8.544-.002-8.606a.805.805 0 0 1 .923-.67c4.844.814 8.274 5.215 7.912 10.15-.361 4.935-4.396 8.778-9.306 8.864-4.91.085-9.077-3.614-9.61-8.534-.534-4.92 2.74-9.437 7.553-10.42" />
        </svg>
        <span>{{'sidebar.log_out'|translate}}</span></a>
    </li>
  </ul>

  <a href="javascript:void(0)" [ngStyle]="{padding: isSmallSidebar ? '10px 5px' : '10px'}" id="sidebarToggle"
    (click)="smallSidebar()" class="toggleActive">
    <span style="float: left;display: block; width: 50%;" [ngStyle]="{fontSize: isSmallSidebar ? '9px' : '9px'}">V
      {{version}}</span>
    <i class="fa fa-chevron-right" aria-hidden="true"></i>
  </a>

</div>
